import { getTermValue, resetTerms, TJsonQueryOptionalKeys, TJsonQueryTermKeys } from '../../../JsonQuery';
import { TTagsManager } from '../types/tag';
import { createTagValue } from './createTagValue';

interface IParams {
  jsonQueryKey: TJsonQueryTermKeys;
  trueLabel: string;
  falseLabel: string;
  id: string;
}

export const createBooleanTagManager = ({ jsonQueryKey, trueLabel, falseLabel, id }: IParams): TTagsManager => ({
  id,
  extractTagsFromJsonQuery: ({ jsonQuery }) => {
    const termValue = getTermValue(jsonQueryKey)(jsonQuery);

    if (termValue === null) {
      return null;
    }

    const label = termValue ? trueLabel : falseLabel;

    return [{ label, value: createTagValue(id) }];
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery }) => resetTerms([jsonQueryKey as TJsonQueryOptionalKeys])(jsonQuery),
});
